
import { map, defaultArg } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { SWR_getStates } from "../Requests/InventoryStates.js";
import { InventoryStateDefinitionModule_selectable, InventoryStateDefinitionModule_allows, InventoryBaseState, InventoryStateDefinitionModule_appliesTo, InventoryBaseStateModule_tryParse, InventoryStateDefinitionModule_tryFind, InventoryBaseState__ToI18nString, InventoryStateDefinitionModule_resolve, InventoryStateDefinitionModule_systemDefinition, InventoryStateDefinitionModule_systemDefinitions } from "../Shared/InventoryStates.js";
import { Operators_IsNull } from "../fable_modules/fable-library-js.5.0.0-rc.2/FSharp.Core.js";
import { ofArray, exists, filter, map as map_1, toArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { List_distinct } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { createObj, stringHash, equals } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { isAvailable } from "./Feature.js";
import Shipment_Time from "../../public/assets/icons/Shipment_Time.svg";
import Shipment_Delivery_Fail from "../../public/assets/icons/Shipment_Delivery_Fail.svg";
import Shipment_Search from "../../public/assets/icons/Shipment_Search.svg";
import Shipment_Check from "../../public/assets/icons/Shipment_Check.svg";
import { createElement } from "react";
import React from "react";
import { defaultOf } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { concat, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { toLocalTime, toString } from "../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { ColoredDot } from "../Components/ColoredDot.js";

export function useDefinitions() {
    return defaultArg(map((_arg) => _arg.States, SWR_getStates().data), InventoryStateDefinitionModule_systemDefinitions);
}

export function resolve(definitions, stateKey, baseState) {
    if (Operators_IsNull(stateKey) ? true : (stateKey === "")) {
        return InventoryStateDefinitionModule_systemDefinition(baseState);
    }
    else {
        return InventoryStateDefinitionModule_resolve(stateKey, baseState, definitions);
    }
}

export function name(t, definition) {
    if (definition.IsSystem) {
        return t(InventoryBaseState__ToI18nString(definition.BaseState));
    }
    else {
        return definition.Name;
    }
}

export function nameOfKey(t, definitions, stateKey) {
    const matchValue = InventoryStateDefinitionModule_tryFind(stateKey, definitions);
    if (matchValue == null) {
        const matchValue_1 = InventoryBaseStateModule_tryParse(stateKey);
        if (matchValue_1 == null) {
            return stateKey;
        }
        else {
            return t(InventoryBaseState__ToI18nString(matchValue_1));
        }
    }
    else {
        return name(t, matchValue);
    }
}

export function defaultFilterNames(t, kinds, definitions) {
    return toArray(List_distinct(map_1((definition_1) => name(t, definition_1), filter((definition) => {
        if (!definition.IsArchived && exists((kind) => InventoryStateDefinitionModule_appliesTo(kind, definition), kinds)) {
            if (equals(definition.BaseState, new InventoryBaseState(0, []))) {
                return true;
            }
            else {
                return equals(definition.BaseState, new InventoryBaseState(1, []));
            }
        }
        else {
            return false;
        }
    }, definitions)), {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    }));
}

export function isOperational(definition) {
    if (!definition.IsSystem ? true : equals(definition.BaseState, new InventoryBaseState(0, []))) {
        return true;
    }
    else {
        return equals(definition.BaseState, new InventoryBaseState(1, []));
    }
}

export function allows(action, definition) {
    if (InventoryStateDefinitionModule_allows(action, definition)) {
        switch (action.tag) {
            case 4:
            case 7:
                return isOperational(definition);
            default:
                return true;
        }
    }
    else {
        return false;
    }
}

export function selectable(accountSettings, kind, definitions) {
    return InventoryStateDefinitionModule_selectable(isAvailable(accountSettings), kind, definitions);
}

export function targets(accountSettings, kind, current, definitions) {
    return filter((definition) => (definition.Key !== current.Key), selectable(accountSettings, kind, definitions));
}

export function targetLabel(t, definition) {
    if (definition.IsSystem) {
        const matchValue = definition.BaseState;
        switch (matchValue.tag) {
            case 1:
                return t("tool.state_in_maintenance");
            case 2:
                return t("general.reject");
            case 3:
                return t("general.report_lost");
            default:
                return t("tool.state_active");
        }
    }
    else {
        return definition.Name;
    }
}

export function targetIcon(definition) {
    const matchValue = definition.BaseState;
    switch (matchValue.tag) {
        case 1:
            return Shipment_Time();
        case 2:
            return Shipment_Delivery_Fail();
        case 3:
            return Shipment_Search();
        default:
            return Shipment_Check();
    }
}

export function dialogTitle(t, i18n, definition) {
    if (definition.IsSystem) {
        const matchValue = definition.BaseState;
        switch (matchValue.tag) {
            case 1:
                return t("tool.in_maintenance_tool");
            case 2:
                return t("tool.retire_tool");
            case 3:
                return t("tool.lost_tool");
            default:
                return t("tool.activate_tool");
        }
    }
    else {
        const arg_1 = {
            name: definition.Name,
        };
        return i18n.t("inventory_state.change_to", arg_1);
    }
}

export function DescriptionHint(props) {
    if (props.Definition.Description === "") {
        return defaultOf();
    }
    else {
        return reactElement("div", {
            className: join(" ", ["text-sm", "text-left", "text-gray-600", "whitespace-pre-wrap"]),
            "data-test-id": "state-change-dialog-description",
            children: props.Definition.Description,
        });
    }
}

export function dateLabel(t, withMaintenanceEndDate, definition) {
    const matchValue = definition.BaseState;
    let matchResult;
    switch (matchValue.tag) {
        case 2:
        case 3: {
            matchResult = 1;
            break;
        }
        case 0: {
            matchResult = 2;
            break;
        }
        default:
            if (withMaintenanceEndDate) {
                matchResult = 0;
            }
            else {
                matchResult = 2;
            }
    }
    switch (matchResult) {
        case 0:
            return t("tool.maintenance_planned_end_date");
        case 1:
            return t("general.date");
        default:
            return undefined;
    }
}

export function stateDateOf(definition, stateDate) {
    const matchValue = definition.BaseState;
    switch (matchValue.tag) {
        case 0:
        case 2:
        case 3:
            return stateDate;
        default:
            return undefined;
    }
}

export function stateText(t, definition, stateDate) {
    const date_1 = defaultArg(map((date) => (("(" + toString(toLocalTime(date), "dd.MM.yyyy")) + ")"), stateDateOf(definition, stateDate)), "");
    return concat(name(t, definition), " ", ...date_1);
}

export function StateDot(props) {
    let matchValue, elems;
    if (props.Definition.IsSystem) {
        return createElement(ColoredDot, {
            Color: (matchValue = props.Definition.BaseState, (matchValue.tag === 1) ? "orange" : ((matchValue.tag === 2) ? "red" : ((matchValue.tag === 3) ? "red" : "green"))),
        });
    }
    else {
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-center", "w-3.5", "h-3.5", "rounded-full"])], ["style", {
            backgroundColor: concat(props.Definition.Color, ..."33"),
        }], ["data-test-id", concat("inventory-state-dot-", ...props.Definition.Key)], (elems = [reactElement("div", {
            className: join(" ", ["w-1.5", "h-1.5", "rounded-full"]),
            style: {
                backgroundColor: props.Definition.Color,
            },
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
}

